import {Attribute} from '../../components/ObjectAttribute';
import {Json} from '../../components/JsonObjectCard';
import searchInventoryRequest from "./requests/searchInventoryRequest";
import addInventoryRequest from "./requests/addInventoryRequest";
import cycleInventoryRequest from "./requests/cycleInventoryRequest";
import moveInventoryRequest from "./requests/moveInventoryRequest";
import scrapInventoryRequest from "./requests/scrapInventoryRequest";
import {RequestDefinitionData} from "../../components/RequestDefinition";

const inventoryEndpoints: RequestDefinitionData[] = [
    searchInventoryRequest,
    addInventoryRequest,
    cycleInventoryRequest,
    moveInventoryRequest,
    scrapInventoryRequest,
];

export const inventoryHeader = {
    title: 'Inventory',
    description: 'This is an object representing the inventory associated with a Fishbowl part.',
    linkName: 'Inventory',
    link: 'https://www.fishbowlinventory.com/wiki/Inventory',
    endpoints: inventoryEndpoints,
};

export const jsonObject: Json = {
    title: 'THE INVENTORY OBJECT',
    json: {}
};

export const inventoryAttributes: Attribute[] = [];
